import React, { Component } from "react";
import { Link } from "gatsby";
import $ from "jquery";

import {
  Collapse,
  NavItem,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  Dropdown,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.dropToggle = this.dropToggle.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.state = {
      isOpen: false,
      dropdownOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  dropToggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  onMouseEnter() {
    this.setState({ dropdownOpen: true });
  }

  onMouseLeave() {
    this.setState({ dropdownOpen: false });
  }

  componentDidMount() {
    $(window).scroll(function() {
      $("nav").toggleClass("scrolled", $(this).scrollTop() > 50);
    });
  }

  render() {
    return (
      <header>
        <Navbar className="my-navbar pt-4 fixed-top" dark expand="lg">
          <NavbarBrand href="/" className="logo">
            Chez Pix Marketing
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} className="text-light" />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem className="pl-md-4">
                <Link className="text-white nav-link navbar-link" to="/">
                  Home
                </Link>
              </NavItem>
              <NavItem className="pl-md-4">
                <Link
                  className="text-white nav-link navbar-link"
                  to="/#company-section"
                >
                  About us
                </Link>
              </NavItem>
              <UncontrolledDropdown
                className="d-inline-block pl-md-4"
                onMouseOver={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
                isOpen={this.state.dropdownOpen}
                toggle={this.dropToggle}
              >
                <DropdownToggle
                  className="services-dropdown text-white nav-link navbar-link"
                  href="/#our-services"
                  caret
                >
                  Our Services
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem href="/#our-services">
                    Custom Website Creation
                  </DropdownItem>
                  <DropdownItem href="/#our-services">
                    Facebook Advertisement
                  </DropdownItem>
                  <DropdownItem href="/#our-services">
                    Website Optimization
                  </DropdownItem>
                  <DropdownItem href="/#our-services">
                    Social Media Management
                  </DropdownItem>
                  <DropdownItem href="/#our-services">
                    Facebook Business Pages
                  </DropdownItem>
                  <DropdownItem href="/#our-services">
                    Other Services
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <NavItem className="pl-md-4">
                <Link
                  className="text-white nav-link navbar-link"
                  to="/#industries-section"
                >
                  Our Industries
                </Link>
              </NavItem>
              <NavItem className="pl-md-4">
                <Link className="text-white nav-link navbar-link" to="/">
                  Contact us
                </Link>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </header>
    );
  }
}

export default NavBar;
